var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "v-container",
        { staticClass: "grey lighten-4", attrs: { fluid: "", "pa-0": "" } },
        [
          _c(
            "v-row",
            { staticStyle: {}, attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "align-self-center",
                  attrs: { md: "auto", xs: "auto", sm: "auto" }
                },
                [
                  _c("crud-button", {
                    attrs: {
                      "x-large": "",
                      color: "blue-grey darken-1",
                      icon: "fa-chevron-left",
                      tooltip: _vm.$t("global.crud.buttons.return")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.back()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass:
                    "flex-grow-1 flex-shrink-0 container-data-filter-info",
                  attrs: { cols: "1" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "pa-0": "" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { sm: "12", cols: "12" } }, [
                            _c("div", { staticClass: "form-field-name" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("timeSlotsClients.client")) +
                                  " "
                              )
                            ]),
                            _c("div", { staticClass: "form-field-value" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.dataFilter.clientCode) +
                                  " - " +
                                  _vm._s(_vm.dataFilter.clientName) +
                                  " "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _vm.$checkPermission("TIMESLOTSCLIENTS")
                    ? _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "light-blue lighten-2",
                          icon: "fa-plus",
                          tooltip: _vm.$t("global.crud.button.add")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.create()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "5", lg: "3", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "dialogTimeSlotClientsFrom",
                                  attrs: {
                                    "return-value": _vm.filter.hourFromString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourFromString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourFromString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlots.timeSlotFrom"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter.hourFromString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "hourFromString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.hourFromString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalTimeSlotClientsFrom,
                                    callback: function($$v) {
                                      _vm.modalTimeSlotClientsFrom = $$v
                                    },
                                    expression: "modalTimeSlotClientsFrom"
                                  }
                                },
                                [
                                  _vm.modalTimeSlotClientsFrom
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogTimeSlotClientsFrom.save(
                                                _vm.filter.hourFromString
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.filter.hourFromString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "hourFromString",
                                                $$v
                                              )
                                            },
                                            expression: "filter.hourFromString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalTimeSlotFrom = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "5", lg: "3", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "dialogTimeSlotClientsTo",
                                  attrs: {
                                    "return-value": _vm.filter.hourToString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourToString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "hourToString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "timeSlots.timeSlotTo"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter.hourToString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "hourToString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.hourToString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalTimeSlotClientsTo,
                                    callback: function($$v) {
                                      _vm.modalTimeSlotClientsTo = $$v
                                    },
                                    expression: "modalTimeSlotClientsTo"
                                  }
                                },
                                [
                                  _vm.modalTimeSlotClientsTo
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogTimeSlotClientsTo.save(
                                                _vm.filter.hourToString
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.filter.hourToString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "hourToString",
                                                $$v
                                              )
                                            },
                                            expression: "filter.hourToString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalTimeSlotClientsTo = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "5", lg: "3", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.deletedItemsValues,
                                  label: _vm.$t("global.status")
                                },
                                model: {
                                  value: _vm.filter.deletedItems,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "deletedItems", $$v)
                                  },
                                  expression: "filter.deletedItems"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: {
                      url: "/timeSlotsClients",
                      filter: this.filter,
                      filterExport: _vm.filterExport
                    }
                  }),
                  _vm.$checkPermission("TIMESLOTSCLIENTS")
                    ? _c("ImportExcel", {
                        attrs: {
                          url: "/timeSlotsClients",
                          filterImport: _vm.filterImport
                        },
                        on: { done: _vm.search }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                "item-key": "code",
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c("tr", { key: item.code }, [
                            _c(
                              "td",
                              [
                                _vm.$checkPermission("TIMESLOTSCLIENTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "orange",
                                        icon: "fa-pen",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.edit"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.edit(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                (item.deletionDate === undefined ||
                                  item.deletionDate === null) &&
                                _vm.$checkPermission("TIMESLOTSCLIENTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "red",
                                        icon: "fa-trash",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.delete"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.suspend(item.code)
                                        }
                                      }
                                    })
                                  : _vm.$checkPermission("TIMESLOTSCLIENTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "green",
                                        icon: "fa-redo",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.restore"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.restore(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.minutesToHour(item.hourFrom)) +
                                  " - " +
                                  _vm._s(_vm.minutesToHour(item.hourTo)) +
                                  " "
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ invalid, validated, passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-container",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c(
                                              "v-dialog",
                                              {
                                                ref:
                                                  "dialogTimeSlotClientsFrom",
                                                attrs: {
                                                  "return-value":
                                                    _vm.item.hourFromString,
                                                  persistent: "",
                                                  width: "290px"
                                                },
                                                on: {
                                                  "update:returnValue": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourFromString",
                                                      $event
                                                    )
                                                  },
                                                  "update:return-value": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourFromString",
                                                      $event
                                                    )
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function({ on }) {
                                                        return [
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                name: _vm.$t(
                                                                  "timeSlotsClients.timeSlotFrom"
                                                                ),
                                                                rules:
                                                                  "required",
                                                                vid:
                                                                  "fieldTimeSlotClientsFrom"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "v-text-field",
                                                                          _vm._g(
                                                                            {
                                                                              attrs: {
                                                                                label: _vm.$t(
                                                                                  "timeSlotsClients.timeSlotFrom"
                                                                                ),
                                                                                readonly:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                "append-icon":
                                                                                  "far fa-clock",
                                                                                "error-messages": errors
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .item
                                                                                    .hourFromString,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.item,
                                                                                    "hourFromString",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.hourFromString"
                                                                              }
                                                                            },
                                                                            on
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.modalTimeSlotClientsFrom,
                                                  callback: function($$v) {
                                                    _vm.modalTimeSlotClientsFrom = $$v
                                                  },
                                                  expression:
                                                    "modalTimeSlotClientsFrom"
                                                }
                                              },
                                              [
                                                _vm.modalTimeSlotClientsFrom
                                                  ? _c(
                                                      "v-time-picker",
                                                      {
                                                        attrs: {
                                                          "full-width": "",
                                                          format: "24hr",
                                                          "allowed-minutes":
                                                            _vm.allowedStepTime
                                                        },
                                                        on: {
                                                          "click:minute": function(
                                                            $event
                                                          ) {
                                                            return _vm.$refs.dialogTimeSlotClientsFrom.save(
                                                              _vm.item
                                                                .hourFromString
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.item
                                                              .hourFromString,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.item,
                                                              "hourFromString",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.hourFromString"
                                                        }
                                                      },
                                                      [
                                                        _c("v-spacer"),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.modalTimeSlotClientsFrom = false
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.cancel"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$refs.dialogTimeSlotClientsFrom.save(
                                                                  _vm.item
                                                                    .hourFromString
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.confirm"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          [
                                            _c(
                                              "v-dialog",
                                              {
                                                ref: "dialogTimeSlotClientsTo",
                                                attrs: {
                                                  "return-value":
                                                    _vm.item.hourToString,
                                                  persistent: "",
                                                  width: "290px"
                                                },
                                                on: {
                                                  "update:returnValue": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourToString",
                                                      $event
                                                    )
                                                  },
                                                  "update:return-value": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.item,
                                                      "hourToString",
                                                      $event
                                                    )
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function({ on }) {
                                                        return [
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                name: _vm.$t(
                                                                  "timeSlotsClients.timeSlotTo"
                                                                ),
                                                                rules:
                                                                  "required|hourBefore:@fieldTimeSlotClientsFrom",
                                                                vid:
                                                                  "fieldTimeSlotClientsTo"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "v-text-field",
                                                                          _vm._g(
                                                                            {
                                                                              attrs: {
                                                                                label: _vm.$t(
                                                                                  "timeSlotsClients.timeSlotTo"
                                                                                ),
                                                                                readonly:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                "append-icon":
                                                                                  "far fa-clock",
                                                                                "error-messages": errors
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .item
                                                                                    .hourToString,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.item,
                                                                                    "hourToString",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.hourToString"
                                                                              }
                                                                            },
                                                                            on
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.modalTimeSlotClientsTo,
                                                  callback: function($$v) {
                                                    _vm.modalTimeSlotClientsTo = $$v
                                                  },
                                                  expression:
                                                    "modalTimeSlotClientsTo"
                                                }
                                              },
                                              [
                                                _vm.modalTimeSlotClientsTo
                                                  ? _c(
                                                      "v-time-picker",
                                                      {
                                                        attrs: {
                                                          "full-width": "",
                                                          format: "24hr",
                                                          "allowed-minutes":
                                                            _vm.allowedStepTime
                                                        },
                                                        on: {
                                                          "click:minute": function(
                                                            $event
                                                          ) {
                                                            return _vm.$refs.dialogTimeSlotClientsTo.save(
                                                              _vm.item
                                                                .hourToString
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.item
                                                              .hourToString,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.item,
                                                              "hourToString",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.hourToString"
                                                        }
                                                      },
                                                      [
                                                        _c("v-spacer"),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.modalTimeSlotClientsTo = false
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.cancel"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              text: "",
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$refs.dialogTimeSlotClientsTo.save(
                                                                  _vm.item
                                                                    .hourToString
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.confirm"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }